"use client";

import { Navbar } from "~/components/Navbar/component";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { Routes } from "~/routes";
import { PrivacyPage } from "~/modules/legal/pages/privacy";

import type { JSX } from "react";

// // // //

export function PrivacyPolicyView(): JSX.Element {
    return (
        <PageTrack route={Routes.privacyPolicy}>
            <UserFetcher>
                {({ user }) => (
                    <Navbar route={Routes.privacyPolicy} user={user} />
                )}
            </UserFetcher>
            <SidebarLayout pathname={Routes.privacyPolicy}>
                <PageWrapper>
                    <PrivacyPage />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
